import { getApiBaseUrl } from '../../../utils/apiConfig';

function authHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

/**
 * Técnicos sem kit (escopo Board: coord só as próprias áreas; admin/gerente todos).
 */
export async function fetchTechniciansWithoutKit() {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/estoque/kit-tecnico/technicians-without-kit`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar técnicos sem kit');
  }
  return json.data;
}

export async function fetchKitFabricantes(filters = {}) {
  const base = getApiBaseUrl();
  const p = new URLSearchParams();
  (filters.subgrupos || []).forEach((s) => p.append('subgrupo', s));
  (filters.equipamentos || []).forEach((e) => p.append('equipamento', e));
  if (filters.q) p.set('q', String(filters.q));
  const qs = p.toString();
  const res = await fetch(`${base}/api/estoque/kit-tecnico/fabricantes${qs ? `?${qs}` : ''}`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar fabricantes');
  }
  return Array.isArray(json.data) ? json.data : [];
}

export async function fetchKitTecnologias(filters = {}) {
  const base = getApiBaseUrl();
  const p = new URLSearchParams();
  (filters.marcas || []).forEach((m) => p.append('marca', m));
  (filters.equipamentos || []).forEach((e) => p.append('equipamento', e));
  if (filters.q) p.set('q', String(filters.q));
  const qs = p.toString();
  const res = await fetch(`${base}/api/estoque/kit-tecnico/tecnologias${qs ? `?${qs}` : ''}`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar tecnologias');
  }
  return Array.isArray(json.data) ? json.data : [];
}

export async function fetchKitEquipamentos(filters = {}) {
  const base = getApiBaseUrl();
  const p = new URLSearchParams();
  (filters.marcas || []).forEach((m) => p.append('marca', m));
  (filters.subgrupos || []).forEach((s) => p.append('subgrupo', s));
  if (filters.q) p.set('q', String(filters.q));
  const qs = p.toString();
  const res = await fetch(`${base}/api/estoque/kit-tecnico/equipamentos${qs ? `?${qs}` : ''}`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar equipamentos');
  }
  return Array.isArray(json.data) ? json.data : [];
}

/**
 * @param {{ marcas?: string[], grupos?: string[], subgrupos?: string[], equipamentos?: string[], q?: string }} filters
 */
export async function fetchKitProdutos(filters = {}) {
  const base = getApiBaseUrl();
  const p = new URLSearchParams();
  (filters.marcas || []).forEach((m) => p.append('marca', m));
  (filters.grupos || []).forEach((g) => p.append('grupo', g));
  (filters.subgrupos || []).forEach((s) => p.append('subgrupo', s));
  (filters.equipamentos || []).forEach((e) => p.append('equipamento', e));
  if (filters.q) p.set('q', String(filters.q));
  const res = await fetch(`${base}/api/estoque/kit-tecnico/produtos?${p}`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar produtos');
  }
  return Array.isArray(json.data) ? json.data : [];
}

/**
 * Modelos de equipamento compatíveis com o produto (peça).
 * @param {string} productCode
 * @returns {Promise<Array<{ equipment_name: string, fabricante: string }>>}
 */
export async function fetchKitCompatibleModels(productCode) {
  const base = getApiBaseUrl();
  const codigo = encodeURIComponent(String(productCode || '').trim());
  const res = await fetch(
    `${base}/api/estoque/kit-tecnico/produtos/${codigo}/modelos-compativeis`,
    { headers: authHeaders() }
  );
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar modelos compatíveis');
  }
  return Array.isArray(json.data) ? json.data : [];
}

/**
 * Estoque por empresa (VW02001) para o produto.
 * @param {string} productCode
 * @returns {Promise<Array<{ companyCode: string, productCode: string, productName: string, stockAvailable: number }>>}
 */
export async function fetchKitProductStocks(productCode) {
  const base = getApiBaseUrl();
  const codigo = encodeURIComponent(String(productCode || '').trim());
  const res = await fetch(`${base}/api/estoque/kit-tecnico/produtos/${codigo}/estoque`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar estoque do produto');
  }
  return Array.isArray(json.data) ? json.data : [];
}

/**
 * @param {string[]} codtechs
 * @param {Array<{ productCode: string, maxQty: number, stock_sources?: Array<{ companyCode: string, stockAvailable?: number }> }|string>} [products]
 * @returns {Promise<object>}
 */
export async function createKits(codtechs, products = []) {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/estoque/kit-tecnico`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ codtechs, products }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    const err = new Error(json.message || 'Erro ao criar kit');
    err.errors = Array.isArray(json.errors) ? json.errors : [];
    throw err;
  }
  return json.data;
}

/**
 * Inclui produtos no kit existente do técnico (INSERT + pedidos).
 * @param {string} codtech
 * @param {Array<{ productCode: string, maxQty: number, stock_sources?: Array<{ companyCode: string, stockAvailable?: number }> }>} products
 */
export async function addKitProducts(codtech, products = []) {
  const base = getApiBaseUrl();
  const code = encodeURIComponent(String(codtech || '').trim());
  const res = await fetch(`${base}/api/estoque/kit-tecnico/${code}/products`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ products }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    const err = new Error(json.message || 'Erro ao adicionar produtos ao kit');
    err.errors = Array.isArray(json.errors) ? json.errors : [];
    throw err;
  }
  return json.data;
}

/** Lista kits dos técnicos com peças (escopo coord/admin). */
export async function fetchKits() {
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/api/estoque/kit-tecnico`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar kits');
  }
  return json.data;
}

/**
 * Pedidos aguardando coleta do técnico (LCMY_LOGIS01).
 * @param {string} codtech
 * @returns {Promise<{ codtech: string, orders: Array<object> }>}
 */
export async function fetchKitPendingPickup(codtech) {
  const base = getApiBaseUrl();
  const code = encodeURIComponent(String(codtech || '').trim());
  const res = await fetch(`${base}/api/estoque/kit-tecnico/${code}/pending-pickup`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar pedidos aguardando coleta');
  }
  return json.data || { orders: [] };
}

/**
 * Movimentações do kit do técnico (LCMY_GO_SERVICE_KIT_MOV).
 * @param {string} codtech
 */
export async function fetchKitMovements(codtech) {
  const base = getApiBaseUrl();
  const code = encodeURIComponent(String(codtech || '').trim());
  const res = await fetch(`${base}/api/estoque/kit-tecnico/${code}/movements`, {
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao carregar movimentações');
  }
  return json.data || { movements: [] };
}

/** Recoloca na fila do ERP um item com falha (cliente no Vervify). */
export async function retryKitErpQueueItem(codtech, id) {
  const base = getApiBaseUrl();
  const code = encodeURIComponent(String(codtech || '').trim());
  const res = await fetch(`${base}/api/estoque/kit-tecnico/${code}/erp-queue/${Number(id)}/retry`, {
    method: 'POST',
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || 'Erro ao reprocessar');
  }
  return json.data;
}

const ERP_QUEUE_LABELS = {
  pending: { label: 'ERP pendente', cor: '#d98207' },
  processing: { label: 'ERP processando', cor: '#3b82f6' },
  failed: { label: 'ERP com falha', cor: '#d64533' },
};

/**
 * Normaliza movimentações da API para a tabela da aba Movimentações.
 * @param {Array<object>} movements
 */
export function mapKitMovements(movements) {
  return (Array.isArray(movements) ? movements : []).map((raw, i) => {
    const type = String(raw.movementType || raw.movement_type || '').trim().toUpperCase();
    const isIn = raw.isEntry != null ? Boolean(raw.isEntry) : type === 'E';
    const qty = Math.trunc(Number(raw.quantity) || 0);
    const reason = String(raw.movementReason || raw.movement_reason || '').trim();
    const reasonLabel =
      raw.reasonLabel ||
      (reason === 'kit_closeout'
        ? 'Devolução'
        : reason === 'wo_usage'
          ? 'OS'
          : reason === 'collected_kit'
            ? 'Pedido'
            : '');
    return {
      id: raw.id ?? i,
      tipo: isIn ? 'Entrada' : 'Saída',
      cor: isIn ? '#168a58' : '#d64533',
      nome: String(raw.productName || raw.product_name || '').trim() || '—',
      cod: String(raw.productCode || raw.product_code || '').trim(),
      ref: String(raw.productReference || raw.product_reference || '').trim(),
      fab: String(raw.brandName || raw.brand_name || '').trim() || '—',
      qtd: qty,
      qtdLabel: String(qty),
      balanceAfter: Math.trunc(Number(raw.balanceAfter ?? raw.balance_after) || 0),
      linha1: String(raw.clientName || raw.cliente || '').trim() || '—',
      linha2: reasonLabel,
      operacao: String(raw.operationCode || raw.operation_code || '').trim(),
      data: String(raw.createdAtLabel || raw.data || '').trim() || '—',
      erpQueue:
        raw.erpQueue && ERP_QUEUE_LABELS[raw.erpQueue.status]
          ? { ...raw.erpQueue, ...ERP_QUEUE_LABELS[raw.erpQueue.status] }
          : null,
    };
  });
}

/**
 * Normaliza pedidos da API para o card “Aguardando coleta” (formato do mock).
 * @param {Array<object>} orders
 */
export function mapPendingPickupOrders(orders) {
  return (Array.isArray(orders) ? orders : []).map((pd) => {
    const rawStatus = String(pd.statusName || pd.status || '').trim() || 'Em andamento';
    const ready = Boolean(pd.readyForPickup ?? pd.liberated);
    const status = ready ? 'Pronto p/ coleta' : rawStatus;
    const data = pd.liberatedAt || pd.data || null;
    const cor = ready ? '#12a06a' : '#d98207';
    return {
      numero: String(pd.order || pd.numero || '').trim(),
      status,
      statusRaw: rawStatus,
      data,
      liberado: ready,
      readyForPickup: ready,
      local: pd.local || '',
      cor,
      itens: (pd.items || pd.itens || []).map((i) => ({
        nome: i.productName || i.nome || i.productCode || i.cod || '—',
        cod: i.productCode || i.cod || '',
        ref: i.productReference || i.ref || '',
        fab: i.brandName || i.fab || '—',
        qtd: Number(i.amount ?? i.qtd) || 0,
      })),
    };
  }).filter((pd) => pd.numero);
}

/**
 * @param {string} codtech
 * @param {Array<{
 *   productCode: string,
 *   quantityMax: number,
 *   stock_sources?: Array<{ companyCode: string, stockAvailable: number }>,
 *   decrease_reason?: 'return_stock'|'keep_with_tech'
 * }>} items
 */
export async function updateKitQuantityMax(codtech, items) {
  const base = getApiBaseUrl();
  const code = encodeURIComponent(String(codtech || '').trim());
  const res = await fetch(`${base}/api/estoque/kit-tecnico/${code}/quantity-max`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify({ items }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    const err = new Error(json.message || 'Erro ao salvar quantidade máxima');
    err.errors = Array.isArray(json.errors) ? json.errors : [];
    throw err;
  }
  return json.data;
}

/** Mapeia resposta da API para o formato consumido por viewTech/calcKit. */
export function mapApiKitToLocal(k) {
  return {
    id: k.codtech || k.id,
    codtech: k.codtech || k.id,
    nome: k.name || k.nome,
    coord: k.coordinatorName || k.coord || '—',
    area: k.areaName || k.area || '—',
    veiculo: k.veiculo || '—',
    ultimaColeta: k.ultimaColeta || '—',
    ultimoUso: k.ultimoUso || '—',
    profilePhotoUrl: k.profilePhotoUrl || null,
    initials: k.initials || null,
    pickupReadyPieces: Number(k.pickupReadyPieces) || 0,
    pickupReadyOrders: Number(k.pickupReadyOrders) || 0,
    itens: (k.items || k.itens || []).map((it) => ({
      productCode: it.productCode || it.cod,
      cod: it.productCode || it.cod,
      nome: it.productName || it.nome,
      ref: String(it.reference || it.REFERENCE || it.ref || '').trim(),
      fab: it.manufacturer || it.fab || '—',
      kit: Number(it.quantityMax ?? it.kit) || 0,
      estoque: Number(it.quantityCurrent ?? it.estoque) || 0,
      prontas: Number(it.prontas) || 0,
      pedido: it.pedido || '',
    })),
  };
}
